import { Button } from '@enterprise-ui/canvas-ui-react'
import React from 'react'
import { useGlobalForm } from '../Context/GlobalFormStateContext'
import { SET_FIELD } from './Constants'
import axios from 'axios'
import { useEnv } from '@praxis/component-runtime-env'
import { EnvConfig } from '../../../config/appConfig'
import { useAuth } from '@praxis/component-auth'
import jsFileDownload from 'js-file-download'
import { DownloadIcon, EnterpriseIcon } from '@enterprise-ui/icons'

interface MainProp {
  value: any
  rowIndex: any
  node: any
}

const DownloadDocument: React.FC<MainProp> = (props) => {
  const auth = useAuth()
  const env = useEnv() as EnvConfig
  const [state, dispatch] = useGlobalForm()
  console.log('DownloadDocument render:', {
    downloadingAttachment: state?.downloadingAttachment,
    propsRowIndex: props.rowIndex,
    typeof_downloadingAttachment: typeof state?.downloadingAttachment,
  })

  const downloadAttachment = async (attachmentId: string, filename: string) => {
    return await axios
      .get(`${env.attachments.attachmentServiceUrl}files/${attachmentId}`, {
        responseType: 'blob',
        headers: {
          'x-api-key': `${env?.apiKey}`,
          Authorization: `Bearer ${auth?.session?.accessToken}`,
        },
      })
      .then((res: any) => {
        if (res.status === 200) {
          jsFileDownload(res.data, filename)
        }
      })
      .catch((reason: any) => {
        dispatch({
          type: SET_FIELD,
          payload: [
            { id: 'downloadingAttachment', value: undefined },
            { id: 'attachmentsError', value: true },
            { id: 'toastHeading', value: 'Error Downloading' },
            {
              id: 'toastMessage',
              value:
                'There was an error downloading the file. Please try again.',
            },
          ],
        })
      })
  }

  const isLoading = (() => {
    const val = state?.downloadingAttachment

    // treat explicit undefined / null / empty as not loading
    if (val === undefined || val === null) return false

    // coerce to string and filter out literal bad strings
    const sval = String(val).trim()
    if (!sval || sval === 'undefined' || sval === 'null') return false

    // final comparison (coerced)
    return sval === String(props.rowIndex)
  })()

  const handleDownload = async () => {
    const loadingKey = String(props.rowIndex)
    console.log('DOWNLOAD start: setting loading ->', {
      loadingKey,
      propsRowIndex: props.rowIndex,
    })
    await dispatch({
      type: SET_FIELD,
      payload: [{ id: 'downloadingAttachment', value: props.node?.rowIndex }],
    })
    let allFiles = state.savedAttachments ? state.savedAttachments : []
    let attachment = allFiles[props.node.rowIndex]
    await downloadAttachment(
      attachment['attachmentId'],
      attachment['fileName'],
    ).then(async () => {
      await dispatch({
        type: SET_FIELD,
        payload: [{ id: 'downloadingAttachment', value: undefined }],
      })
    })
  }
  return (
    <Button
      xs={1}
      onClick={() => handleDownload()}
      isLoading={state.downloadingAttachment === props.node.rowIndex}
    >
      <EnterpriseIcon icon={DownloadIcon} />
    </Button>
  )
}

export default DownloadDocument
